import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectUserList = (state) => state.userList || initialState

const makeSelectUserList = () => createSelector(
  selectUserList,
  (state) => state
)

export {
  selectUserList,
  makeSelectUserList
}
